<p-splitter [panelSizes]="[30, 70]" orientation="horizontal">
    <ng-template pTemplate>
        <!-- min-height is applied here because its not working if applied on p-splitter -->
        <div class="flex flex-col w-full" [style.min-height]="minHeightInPt() + 'pt'">
            <div class="flex items-center content-center gap-1 m-2">
                <!-- PRICE REFERENCE WARNING OR NORMAL HEADER -->
                @if (hasPriceReferenceProduct()) {
                    <!-- Price Reference Mode Header -->
                    <div
                        class="flex items-center gap-2 w-full bg-primary-50 dark:bg-primary-900/20 p-2 rounded-md border border-primary-200 dark:border-primary-800"
                    >
                        <i
                            class="fas fa-link text-primary-600 dark:text-primary-400"
                            [attr.data-testid]="
                                'formly-product-customer-product-price-edit-widget-fas-fa-link'
                            "
                        ></i>
                        <span class="text-primary-700 dark:text-primary-300 font-medium text-sm">
                            {{ 'product.prices-of' | translate }}
                            <a
                                class="underline hover:text-primary-800 dark:hover:text-primary-200 transition-colors"
                                [routerLink]="['/products/edit', priceReferenceProductId()]"
                                [attr.data-product-id]="priceReferenceProductId()"
                                [attr.data-testid]="
                                    'formly-product-customer-product-price-edit-widget-a'
                                "
                            >
                                {{ priceReferenceProductIdentifier() }}
                            </a>
                        </span>
                        <i
                            class="fas fa-external-link-alt text-primary-500 dark:text-primary-400 text-xs ml-auto cursor-pointer hover:text-primary-600 dark:hover:text-primary-300 transition-colors"
                            (click)="openInNewTab()"
                            pTooltip="common.open-in-new-tab"
                            [attr.data-testid]="
                                'formly-product-customer-product-price-edit-widget-fas-fa-external-link-alt'
                            "
                        ></i>
                    </div>
                } @else {
                    <!-- QUANTITY -->
                    <span pTooltip="{{ 'product.price-list-quantity' | translate }}">
                        <p-badge
                            [value]="fieldsSig().length"
                            [attr.data-testid]="
                                'formly-product-customer-product-price-edit-widget-p-badge'
                            "
                        ></p-badge>
                    </span>
                    <h6 [attr.data-testid]="'formly-product-customer-product-price-edit-widget-h6'">
                        {{ 'product.address-prices' | translate }}
                    </h6>
                    <!-- ADD CUSTOMER PRICE LIST -->
                    <p-button
                        size="small"
                        (onClick)="handlePriceList('save')"
                        icon="fa fa-plus"
                        text="true"
                        [attr.data-testid]="
                            'formly-product-customer-product-price-edit-widget-p-button'
                        "
                    >
                    </p-button>
                    <!-- DELETE CUSTOMER PRICE LIST -->
                    @if (customerPriceListNodeSelectedSig()) {
                        <p-button
                            size="small"
                            severity="danger"
                            pTooltip="{{ 'price-list.delete' | translate }}"
                            (onClick)="deleteCustomerPriceListWithConfirm()"
                            icon="fa fa-trash"
                            text="true"
                            [attr.data-testid]="
                                'formly-product-customer-product-price-edit-widget-p-button'
                            "
                        >
                        </p-button>
                    }
                }
            </div>
            <hr />
            <!-- LISTBOX ITEMS -->
            @if (isLoadingSig()) {
                <p-skeleton
                    height="2.5rem"
                    class="flex"
                    styleClass="m-1"
                    [attr.data-testid]="
                        'formly-product-customer-product-price-edit-widget-p-skeleton'
                    "
                />
            } @else {
                <p-listbox
                    #pListbox
                    [options]="fieldsSig()"
                    [(ngModel)]="customerPriceListNodeSelectedSig"
                    [multiple]="false"
                    [metaKeySelection]="true"
                    dataKey="id"
                    [listStyle]="{
                        maxHeight:
                            (fieldsSig().length | calculateListHeight: 40 : 100 : 0.7) + 'px',
                        width: '100%'
                    }"
                    (onChange)="loadItemsOfPriceList()"
                    styleClass="w-full flex border-surface-0 dark:border-surface-900"
                    [striped]="true"
                    [attr.data-testid]="
                        'formly-product-customer-product-price-edit-widget-p-listbox'
                    "
                >
                    <ng-template let-item #item>
                        <app-price-list-display-row-widget
                            [noCreditorNumber]="true"
                            [priceListSig]="item.customerPriceList"
                            [currentPriceEntrySig]="currentPriceEntryFor(item)"
                            [addressSig]="item.address"
                            [dataTestid]="
                                dataTestid() +
                                '-customer-product-price-edit-widget-price-list-display-row-widget'
                            "
                        />
                    </ng-template>
                </p-listbox>
            }
        </div>
    </ng-template>
    <ng-template pTemplate #content>
        <ngx-ui-loader #loader [loaderId]="'loader-present-customer-prices'" />

        <div class="flex flex-col w-full h-full">
            <!-- PRICE REFERENCE MODE HEADER FOR RIGHT PANEL -->
            @if (hasPriceReferenceProduct()) {
                <div
                    class="flex items-center gap-2 w-full bg-primary-50 dark:bg-primary-900/20 p-3 m-2 rounded-md border border-primary-200 dark:border-primary-800"
                >
                    <i
                        class="fas fa-link text-primary-600 dark:text-primary-400"
                        [attr.data-testid]="
                            'formly-product-customer-product-price-edit-widget-fas-fa-link'
                        "
                    ></i>
                    <span class="text-primary-700 dark:text-primary-300 font-medium">
                        {{ 'product.prices-of' | translate }}
                        <a
                            class="underline hover:text-primary-800 dark:hover:text-primary-200 transition-colors"
                            [routerLink]="['/products/edit', priceReferenceProductId()]"
                            [attr.data-product-id]="priceReferenceProductId()"
                            [attr.data-testid]="
                                'formly-product-customer-product-price-edit-widget-a'
                            "
                        >
                            {{ priceReferenceProductIdentifier() }}
                        </a>
                    </span>
                    <i
                        class="fas fa-external-link-alt text-primary-500 dark:text-primary-400 text-sm ml-auto cursor-pointer hover:text-primary-600 dark:hover:text-primary-300 transition-colors"
                        (click)="openInNewTab()"
                        pTooltip="Open in new tab"
                        [attr.data-testid]="
                            'formly-product-customer-product-price-edit-widget-fas-fa-external-link-alt'
                        "
                    ></i>
                    <i
                        class="fas fa-info-circle text-primary-600 dark:text-primary-400"
                        pTooltip="{{ 'product.price-reference-info' | translate }}"
                        [attr.data-testid]="
                            'formly-product-customer-product-price-edit-widget-fas-fa-info-circle'
                        "
                    ></i>
                </div>
            }

            @if (!customerPriceListNodeSelectedSig()) {
                <div
                    class="flex justify-center items-center choose-ngifloader-splitter"
                    style="height: 100%; width: 100%"
                >
                    <div
                        class="shine"
                        [attr.data-testid]="
                            'formly-product-customer-product-price-edit-widget-shine'
                        "
                    >
                        <h3
                            [attr.data-testid]="
                                'formly-product-customer-product-price-edit-widget-h3'
                            "
                        >
                            {{ 'product.customer-pricelist-choose' | translate }}
                        </h3>
                    </div>
                </div>
            }
            <div [hidden]="!customerPriceListNodeSelectedSig()" class="w-full">
                <div
                    class="ms-3 mt-2 mb-1 flex items-center gap-2 text-sm text-muted-color italic"
                    [attr.data-testid]="
                        'formly-product-customer-product-price-edit-widget-discount-hint'
                    "
                >
                    <i class="fa fa-info-circle"></i>
                    {{ 'common.customer-price-discount-hint' | translate }}
                </div>
                @if (customerPriceListNodeSelectedSig()) {
                    <div>
                        <app-price-list-entry-list-widget
                            #priceListEntryListWidget
                            [product]="product()"
                            [listType]="PriceListType.CUSTOMER"
                            [debitorAddressId]="customerPriceListNodeSelectedSig()?.addressId"
                            [debitorIdentifier]="
                                customerPriceListNodeSelectedSig()?.address?.debitor?.identifier
                            "
                            [productIdToUse]="product()?.priceReferenceProductId"
                            [noSort]="true"
                            [paginator]="false"
                            [priceList]="customerPriceListNodeSelectedSig().customerPriceList"
                            [withBulkPrices]="true"
                            [addInDetail]="false"
                            [onlyActive]="true"
                            [readonly]="hasPriceReferenceProduct()"
                            [noAddNew]="hasPriceReferenceProduct()"
                            [noDelete]="hasPriceReferenceProduct()"
                            [noBaseEdit]="true"
                            [noCopy]="true"
                            [inlineEditMode]="!hasPriceReferenceProduct()"
                            [hasPriceReferenceProduct]="hasPriceReferenceProduct()"
                            [dataTestId]="
                                'formly-product-customer-product-price-edit-widget-price-list-entry-list-widget-1'
                            "
                            (onSaved)="priceListEntryHistoryListWidget()?.refresh()"
                        />
                    </div>
                }
                <div class="ms-3 mt-4 mb-2" *ngIf="!hasPriceReferenceProduct()">
                    <input
                        type="checkbox"
                        [checked]="historyCheckedSig()"
                        (click)="historyCheckedSig.set(!historyCheckedSig())"
                        [attr.data-testid]="
                            'formly-product-customer-product-price-edit-widget-checkbox'
                        "
                    />
                    {{ 'product.price-view-history' | translate }}
                </div>
                @if (
                    historyCheckedSig() &&
                    customerPriceListNodeSelectedSig() &&
                    !hasPriceReferenceProduct()
                ) {
                    <hr class="mt-2 mb-4" />
                    <div>
                        <h5
                            class="mb-4 ms-2 mt-2"
                            [attr.data-testid]="
                                'formly-product-customer-product-price-edit-widget-h5'
                            "
                        >
                            {{ 'product.price-edit-oldprices' | translate }}
                        </h5>
                        <app-price-list-entry-list-widget
                            #priceListEntryHistoryListWidget
                            [product]="product()"
                            [productIdToUse]="product()?.priceReferenceProductId"
                            [listType]="PriceListType.CUSTOMER"
                            [debitorAddressId]="customerPriceListNodeSelectedSig()?.addressId"
                            [autoloadItems]="true"
                            [priceList]="customerPriceListNodeSelectedSig().customerPriceList"
                            [onlyHistory]="true"
                            [noCopy]="true"
                            [noAddNew]="true"
                            [noDelete]="true"
                            [noBaseEdit]="true"
                            [hasPriceReferenceProduct]="hasPriceReferenceProduct()"
                            [dataTestId]="
                                'formly-product-customer-product-price-edit-widget-price-list-entry-list-widget-2'
                            "
                        />
                    </div>
                }
            </div>
        </div>
    </ng-template>
</p-splitter>

<p-dialog
    #chooseDialog
    [draggable]="true"
    [(visible)]="copyOrEditPriceListDialogVisible"
    [resizable]="true"
    (close)="chooseDialogSig().closable = true"
    showCloseIcon="true"
    modal="true"
    width="600px"
    [attr.data-testid]="'formly-product-customer-product-price-edit-widget-choose-dialog'"
>
    <app-address-drop-down
        #addressDropDown
        (valueChange)="setSelectedAddress($event)"
        [externalDataTestId]="true"
        [dataTestId]="'formly-product-customer-product-price-edit-widget-address-drop-down'"
    />
    @if (addressAlreadyLinked(selectedAddressSig())) {
        <div
            class="alert alert-warning mt-2"
            [attr.data-testid]="'formly-product-customer-product-price-edit-widget-alert-warning'"
        >
            {{ 'products.customer-pricelist-address-already-linked' | translate }}
        </div>
    }
    <p-button
        styleClass="mt-2"
        (onClick)="copyOrSaveCustomerPriceList(selectedAddressSig())"
        [hidden]="addressAlreadyLinked(selectedAddressSig())"
        [attr.data-testid]="'formly-product-customer-product-price-edit-widget-save-button'"
    >
        {{ 'common.save' | translate }}
    </p-button>
</p-dialog>
